import { render, staticRenderFns } from "./InputNumeric.vue?vue&type=template&id=64032896&"
import script from "./InputNumeric.vue?vue&type=script&lang=js&"
export * from "./InputNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports